import AuthPageWrapper from '@/components/authPage/AuthPageWrapper';
import Layout from '@/components/layout/LayoutWrapper';
import { useAuthPrompt } from '@/context/auth/AuthPromptProvider';
import { InitRequest, useInitState } from '@/hooks/store';
import { useComponentDidMount } from '@/hooks/utils/useComponentDidMount';

const Login = () => {
	const { setAuthPrompt } = useAuthPrompt();

	useInitState({
		requests: [InitRequest.USER, InitRequest.DEVICE],
	});

	useComponentDidMount(() => {
		setAuthPrompt('login');
	});

	return (
		<Layout pageName="login">
			<AuthPageWrapper />
		</Layout>
	);
};

export default Login;
